import { MessageCircle } from "lucide-react";
import { SITE } from "@/data/site";

export const WhatsAppFab = () => (
  <a
    href={SITE.whatsapp()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-fab"
    className="fixed bottom-6 left-6 z-40 flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-lg hover:scale-105 transition-transform"
  >
    <MessageCircle size={22} />
    <span className="font-semibold text-sm hidden sm:inline">WhatsApp Now</span>
  </a>
);
